var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 29.1665,
    height: 15.8331,
    viewBox: "0 0 29.1665 15.8331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M27.0328 0.366117C27.5209 -0.122039 28.3122 -0.122038 28.8004 0.366117C29.2885 0.854272 29.2885 1.64554 28.8004 2.13369L15.467 15.467C14.9789 15.9552 14.1876 15.9552 13.6995 15.467L0.366117 2.13369C-0.122039 1.64554 -0.122039 0.854272 0.366117 0.366117C0.854272 -0.122039 1.64554 -0.122039 2.13369 0.366117L14.5832 12.8157L27.0328 0.366117Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.28f7c1b90ef5405e7ba167df70ea8a8c.svg";
export { ForwardRef as ReactComponent };